// frontend/src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';

// Pages publiques
import Home from './pages/Home';
import Services from './pages/Services';
import Realizations from './pages/Realizations';
import Contact from './pages/Contact';
import About from './pages/About';
import Internship from './pages/InternshipForm';
import CGU from './pages/CGU';
import Login from './pages/Login';

// Pages admin
import Dashboard from './pages/Admin/Dashboard';
import ManageCategories from './pages/Admin/ManageCategories';
import ManageServices from './pages/Admin/ManageServices';
import ManageRealizations from './pages/Admin/ManageRealizations';
import ManageInternships from './pages/Admin/ManageInternships';
import ManageApplications from './pages/Admin/ManageApplications';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              {/* Routes publiques */}
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/realizations" element={<Realizations />} />
              <Route path="/internship" element={<Internship />} />
              <Route path="/internship/CGU" element={<CGU />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/login" element={<Login />} />
              {/* Routes admin protégées */}
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/categories"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageCategories />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/services"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageServices />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/realizations"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageRealizations />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/internships"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageInternships />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin/applications"
                element={
                  <ProtectedRoute adminOnly>
                    <ManageApplications />
                  </ProtectedRoute>
                }
              />
              {/* Redirection par défaut */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;



